import { OrderType } from "@prisma/client";
import { forwardRef } from "react";

import { orderTypeDisplayMap } from "~/shared/orders/order-type";
import { Flex, MultiSelect, type MultiSelectProps, Select, type SelectProps, Text } from "~/ui";

export { isDirectShip } from "~/shared/orders/order-type";

const descriptions = {
  [OrderType.STOCK_ORDER]: "Product line items must come from existing Lots of inventory.",
  [OrderType.DIRECT_SHIP]:
    "Creates a linked PO automatically with a “Direct Ship Orders” warehouse. The Ship-To and Ship-From will be same on the SO and PO.",
  [OrderType.BLIND_SHIP]:
    "Creates a linked PO automatically. The Ship-To on the PO will use the Direct Ship Warehouse address and appear as Customer Pickup.",
};

const statusOptions = Array.from(orderTypeDisplayMap).map(([term, text]) => ({
  value: term,
  label: text,
  description: descriptions[term],
}));

interface OrderTypeItemProps extends React.ComponentPropsWithoutRef<"div"> {
  label: string;
  description: string;
}
const OrderTypeItem = forwardRef<HTMLDivElement, OrderTypeItemProps>(({ label, description, ...others }: OrderTypeItemProps, ref) => (
  <Flex {...others} ref={ref} direction="column">
    <Text weight="bold">{label}</Text>
    <Text size="xs" style={{ wordBreak: "break-word" }}>
      {description}
    </Text>
  </Flex>
));
OrderTypeItem.displayName = "OrderTypeItem";

export const OrderTypeSelect = (props: Omit<SelectProps, "data">) => (
  <Select placeholder="Order Type" searchable clearable itemComponent={OrderTypeItem} {...props} data={statusOptions} />
);

export const OrderTypeMultiSelect = (props: Omit<MultiSelectProps, "data">) => (
  <MultiSelect placeholder="Order Type" searchable clearable {...props} data={statusOptions} />
);
